<div class="main-container" [ngClass]="{ 'sidenav-open': isSidenavOpen }">
  <mat-sidenav-container>
    <mat-sidenav
      #snav
      class="menu-container"
      mode="over"
      fixedTopGap="56"
      (openedChange)="onOpenedChange($event)"
    >
      <rfc-sidenav [snav]="snav" [sideNavItems]="sideNavItems"></rfc-sidenav>
    </mat-sidenav>

    <mat-sidenav-content [ngClass]="{ 'sidenav-open-content': isSidenavOpen }">
      <ald-header [snav]="snav"></ald-header>
      <div class="main-page-container">
        <!-- Loading spinner -->

        <rfc-breadcrumb></rfc-breadcrumb>
        <router-outlet> </router-outlet>
      </div>
      <ald-footer></ald-footer>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<div *ngIf="loading" class="loading-container flex-content-center">
  <mat-spinner class="spinner"></mat-spinner>
</div>
